import { useDispatch, useSelector } from 'react-redux';

import { useTheme } from '@mui/material/styles';
import {
    Button,
    Box,
    FormControl,
    InputLabel,
    Grid,
    Stack,
    Divider,
    Breadcrumbs,
    IconButton,
    Typography,
    Popover,
    List,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Input,
    Modal
} from '@mui/material';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import FormFields from 'Components/FormFields';
import {
    setSelectedCsvItem,
    setSelectedCsvItemIndex,
    setModalOpen,
    setModalType,
    setParseDataOfCsvFile
} from 'store/ResponseTemplate/actions';
import BackIcon from 'Components/Icons/BackIcon';
import { useEffect, useState } from 'react';
import QuestionRegistryIcon from 'Components/Icons/QuestionRegistryIcon';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { MoreHoriz } from '@mui/icons-material';
import TrashIcon from 'Components/Icons/TrashIcon';

const EditTemplateCSV = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { selectedCsvItem, selectedCsvItemIndex, parsedCsvData } = useSelector((params) => params.response);
    const [anchorEl, setAnchorEl] = useState(null);
    // const [openModal, setOpenModal] = useState(false);
    const [title, setTitle] = useState(selectedCsvItem?.Question);

    const handleOpenModal = () => {
        // handleClose();
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'delete-csv' });
        // dispatch({ type: setActionType, typeOfAction: 'A' });
    };
    // const handleCloseModal = () => {
    //     handleClose();
    //     setOpenModal(false);
    // };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleClose = () => {
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalType, modalType: 'list_csv_data' });
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setSelectedCsvItem, selectedCsvItem: null });
        dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: -1 });
    };

    const handleSave = (values) => {
        if (parsedCsvData && parsedCsvData?.length) {
            const newParsedCsvData = [...parsedCsvData];
            newParsedCsvData[selectedCsvItemIndex] = {
                Question: values.Question,
                Response: values.Response
            };
            dispatch({ type: setParseDataOfCsvFile, parsedCsvData: newParsedCsvData });
        }
        handleClose();
    };

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'csv-delete-popover' : undefined;

    useEffect(() => {
        if (!title) {
            setTitle(selectedCsvItem?.Question);
        }
    }, [title]);

    return (
        <>
            <Stack sx={{ padding: '24px 24px 16px' }} direction="row" justifyContent="space-between">
                <Stack direction="row">
                    <IconButton
                        disableRipple
                        sx={{
                            padding: '0'
                        }}
                        onClick={() => {
                            dispatch({ type: setModalOpen, modalOpen: true });
                            dispatch({ type: setModalType, modalType: 'list_csv_data' });
                        }}
                    >
                        <BackIcon />
                    </IconButton>
                    <Typography
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            position: 'relative',
                            paddingLeft: '17px',
                            '&:before': {
                                content: '""',
                                position: 'absolute',
                                width: '1px',
                                height: '100%',
                                top: '0',
                                left: '8px',
                                background: '#EDE7F6'
                            }
                        }}
                        color="#00214D"
                        fontWeight="600"
                        component="span"
                        fontSize="0.875rem"
                        lineHeight="1.1"
                    >
                        <QuestionRegistryIcon />
                        {title}
                    </Typography>
                </Stack>
                <Stack direction="row" className="actions">
                    <IconButton className="three-dots" disableRipple onClick={handleClick}>
                        <MoreHoriz className="dot" />
                    </IconButton>
                </Stack>
            </Stack>
            <Divider sx={{ backgroundColor: '#EDE7F6' }} />
            <Box className="modal-body">
                <Formik
                    initialValues={{
                        Question: selectedCsvItem?.Question || '',
                        Response: selectedCsvItem?.Response || ''
                    }}
                    validationSchema={Yup.object().shape({
                        Question: Yup.string().required('Please provide a question.'),
                        Response: Yup.string().required('Please provide a response.')
                    })}
                    onSubmit={(values) => handleSave(values)}
                >
                    {({ handleBlur, handleChange, values }) => (
                        <Form>
                            <Stack>
                                <Stack className="field-box" gap={1}>
                                    <FormControl sx={{ ...theme.typography.customInput }}>
                                        {/* <InputLabel htmlFor="outlined-adornment-title">Question</InputLabel> */}
                                        {/* <FormFields
                                            type="outlined-input"
                                            name="Question"
                                            label="Question"
                                            value={values.Question}
                                            id="outlined-adornment-title"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            inputprops={{}}
                                        /> */}
                                        <Input
                                            type="outlined-input"
                                            name="Question"
                                            value={values.Question}
                                            id="outlined-adornment-title"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                setTitle(e.target.value !== '' ? e.target.value : selectedCsvItem?.Question);
                                                handleChange(e);
                                            }}
                                            inputprops={{}}
                                        />
                                    </FormControl>

                                    <FormControl sx={{ ...theme.typography.customInput }} className="contact-textarea-formcontrol">
                                        {/* <InputLabel htmlFor="outlined-adornment-text-response">Response</InputLabel> */}
                                        {/* <FormFields
                                            id="outlined-adornment-responsetext-response"
                                            type="outlined-input"
                                            value={values.Response}
                                            name="Response"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Response"
                                            multiline
                                            rows={4}
                                        /> */}

                                        <Input
                                            id="outlined-adornment-responsetext-response"
                                            type="outlined-input"
                                            value={values.Response}
                                            name="Response"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Response"
                                            multiline
                                            rows={4}
                                        />
                                    </FormControl>
                                </Stack>

                                <Stack
                                    justifyContent="flex-end"
                                    direction="row"
                                    sx={{
                                        padding: '16px'
                                    }}
                                >
                                    <Button
                                        type="submit"
                                        className="alternate white"
                                        disabled={!values.Question || !values.Response}
                                        startIcon={<CheckRoundedIcon />}
                                        disableRipple
                                    >
                                        Save
                                    </Button>
                                </Stack>
                            </Stack>

                            {/* <Grid container rowSpacing={1.5}>
                                <Grid item xs={12}>
                                    <FormControl sx={{ ...theme.typography.customInput }}>
                                        <InputLabel htmlFor="outlined-adornment-title">Question</InputLabel>
                                        <FormFields
                                            type="outlined-input"
                                            name="Question"
                                            label="Question"
                                            value={values.Question}
                                            id="outlined-adornment-title"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            inputprops={{}}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl sx={{ ...theme.typography.customInput }} className="contact-textarea-formcontrol">
                                        <InputLabel htmlFor="outlined-adornment-text-response">Response</InputLabel>
                                        <FormFields
                                            id="outlined-adornment-responsetext-response"
                                            type="outlined-input"
                                            value={values.Response}
                                            name="Response"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="Response"
                                            multiline
                                            rows={4}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box className="modal-footer float-right">
                                        <Button className="alternate-reversed" onClick={handleClose}>
                                            Cancel
                                        </Button>
                                        <Button type="submit" className="alternate">
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid> */}
                        </Form>
                    )}
                </Formik>
            </Box>
            <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                className="csv-delete-popover"
                sx={{
                    width: '200px'
                }}
            >
                <Box className="popover-wrap">
                    <List>
                        <MenuItem onClick={handleOpenModal} disableRipple>
                            <ListItemIcon>{<TrashIcon />}</ListItemIcon>
                            <ListItemText>Remove question</ListItemText>
                        </MenuItem>
                    </List>
                </Box>
            </Popover>
        </>
    );
};

export default EditTemplateCSV;
